import React, { useState } from 'react'

// components

import CardLineChart from 'components/Cards/CardLineChart'
import CardStoreStatsDates from 'components/Cards/CardStoreStatsDates'
import CardBarDailySales from 'components/Cards/CardBarDailySales'
import CardBarDailyInvoices from 'components/Cards/CardBarDailyInvoices'
import CardStoresSumStats from 'components/Cards/CardStoresSumStats'

export default function Statistics() {
    const [storeId, setStoreId] = useState(null)
    const [startDate, setStartDate] = useState(null)
    const [endDate, setEndDate] = useState(null)
    let [update, setUpdate] = useState(0)

    const handleSearchChange = data => {
        console.log(`handleSearchChange()`)
        const { storeId, startDate, endDate } = data
        setStoreId(storeId)
        setStartDate(startDate)
        setEndDate(endDate)
        setUpdate(update + 1)
    }

    return (
        <>
            <div className="flex flex-wrap">
                <div className="w-full xl:w-12/12 px-4">
                    <CardStoreStatsDates handler={handleSearchChange} />
                </div>
                <div className="w-full xl:w-12/12 px-4">
                    <CardStoresSumStats storeId={storeId} startDate={startDate} endDate={endDate} update={update} />
                </div>
                <div className="w-full xl:w-12/12 px-4">
                    <CardBarDailySales storeId={storeId} startDate={startDate} endDate={endDate} update={update} />
                </div>
                <div className="w-full xl:w-12/12 px-4">
                    <CardBarDailyInvoices storeId={storeId} startDate={startDate} endDate={endDate} update={update} />
                </div>
                {/* <div className="w-full xl:w-12/12 mb-12 xl:mb-0 px-4">
                    <CardLineChart storeId={storeId} startDate={startDate} endDate={endDate} />
                </div> */}
            </div>
        </>
    )
}
